<!--Agora-->
<template>
  <div class="flex-column flex-justify-start flex-align-center">
    <div id="player" style="width: 720px; height: 420px; border: 1px solid;"></div>
    <p style="font-size: 24px; color: #fff;">选择的直播流源</p>
    <div class="flex-row flex-justify-center flex-align-center mt10">
      <template v-if="livePara.liveState && dronePara.isDockLive">
        <span class="mr10">镜头:</span>
        <a-radio-group v-model:value="dronePara.lensSelected" button-style="solid">
          <a-radio-button v-for="lens in dronePara.lensList" :key="lens" :value="lens">{{lens}}</a-radio-button>
        </a-radio-group>
      </template>
      <template v-else>
      <a-select
        style="width:150px"
        placeholder="选择飞行器"
        v-model:value="dronePara.droneSelected"
      >
        <a-select-option
          v-for="item in dronePara.droneList"
          :key="item.value"
          :value="item.value"
          @click="onDroneSelect(item)"
          >{{ item.label }}</a-select-option
        >
      </a-select>
      <a-select
        class="ml10"
        style="width:150px"
        placeholder="选择摄像头"
        v-model:value="dronePara.cameraSelected"
      >
        <a-select-option
          v-for="item in dronePara.cameraList"
          :key="item.value"
          :value="item.value"
          @click="onCameraSelect(item)"
          >{{ item.label }}</a-select-option
        >
      </a-select>
      <!-- <a-select
        class="ml10"
        style="width:150px"
        placeholder="Select Lens"
        @select="onVideoSelect"
      >
        <a-select-option
          v-for="item in dronePara.videoList"
          :key="item.value"
          :value="item.value"
          >{{ item.label }}</a-select-option
        >
      </a-select> -->
      </template>
      <a-select
        class="ml10"
        style="width:150px"
        placeholder="选择清晰度"
        @select="onClaritySelect"
      >
        <a-select-option
          v-for="item in clarityList"
          :key="item.value"
          :value="item.value"
          >{{ item.label }}</a-select-option
        >
      </a-select>
    </div>
    <div class="flex-row flex-justify-center flex-align-center">
      <span style="color: #fff; margin-right: 10px;">AppId:</span>
      <a-input v-model:value="agoraPara.appid" placeholder="APP ID"></a-input>
      <span style="color: #fff; margin-left: 10px;">Token:</span>
      <a-input
        class="ml10"
        v-model:value="agoraPara.token"
        placeholder="Token"
      ></a-input>
      <span style="color: #fff; margin-left: 10px;">Channel:</span>
      <a-input
        class="ml10"
        v-model:value="agoraPara.channel"
        placeholder="Channel"
      ></a-input>
    </div>
    <div class="mt20 flex-row flex-justify-center flex-align-center">
      <a-button v-if="livePara.liveState && dronePara.isDockLive" type="primary" large @click="onSwitch">切换镜头</a-button>
      <a-button v-else type="primary" large @click="onStart">开始</a-button>
      <a-button class="ml20" type="primary" large @click="onStop">暂停</a-button>
      <a-button class="ml20" type="primary" large @click="onUpdateQuality">更新清晰度</a-button>
      <a-button v-if="!livePara.liveState || !dronePara.isDockLive" class="ml20" type="primary" large @click="onRefresh">刷新实时容量</a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AgoraRTC, { IAgoraRTCClient, IAgoraRTCRemoteUser } from 'agora-rtc-sdk-ng'
import { message } from 'ant-design-vue'
import { onMounted, reactive, ref } from 'vue'
import { CURRENT_CONFIG as config, CURRENT_CONFIG } from '/@/api/http/config'
import { changeLivestreamLens, getAgoraToken, getLiveCapacity, setLivestreamQuality, startLivestream, stopLivestream } from '/@/api/manage'
import { getRoot } from '/@/root'
import { SystemTitleKey } from '/@/types'

const root = getRoot()

const clarityList = [
  {
    value: 0,
    label: '自适应'
  },
  {
    value: 1,
    label: '流畅'
  },
  {
    value: 2,
    label: '标准'
  },
  {
    value: 3,
    label: '高清'
  },
  {
    value: 4,
    label: '超清'
  }
]

interface SelectOption {
  value: any,
  label: string,
  more?: any
}

// 获取环境变量 AGORA_APP_ID 的值。请确保你将该变量设为你在声网控制台获取的 App ID
const appId = CURRENT_CONFIG.agoraAPPID
// 获取环境变量 AGORA_APP_CERTIFICATE 的值。请确保你将该变量设为你在声网控制台获取的 App 证书
const appCertificate = CURRENT_CONFIG.agoraCertificate
// 将 channelName 替换为需要加入的频道名
const channelName = CURRENT_CONFIG.agoraChannel

console.log('AgoraParaAppId:', appId, 'AgoraParaAppCertificate:', appCertificate, 'AgoraParaChannelName:', channelName)

let agoraClient = {} as IAgoraRTCClient
const agoraPara = reactive({
  appid: config.agoraAPPID,
  token: localStorage.getItem(SystemTitleKey.Agora_Token),
  channel: config.agoraChannel,
  uid: 123456,
  stream: {}
})
const dronePara = reactive({
  livestreamSource: [],
  droneList: [] as SelectOption[],
  cameraList: [] as SelectOption[],
  videoList: [] as SelectOption[],
  droneSelected: undefined as string | undefined,
  cameraSelected: undefined as string | undefined,
  videoSelected: undefined as string | undefined,
  claritySelected: 0,
  lensList: [] as string[],
  lensSelected: undefined as string | undefined,
  isDockLive: false
})
const livePara = reactive({
  url: '',
  webrtc: {} as any,
  videoId: '',
  liveState: false
})
const nonSwitchable = 'normal'
const onRefresh = async () => {
  dronePara.droneList = []
  dronePara.cameraList = []
  dronePara.videoList = []
  dronePara.droneSelected = undefined
  dronePara.cameraSelected = undefined
  dronePara.videoSelected = undefined
  await getLiveCapacity({})
    .then(res => {
      if (res.code === 0) {
        if (res.data === null) {
          console.warn('警告: 获取实时容量为空!!!')
          return
        }
        dronePara.livestreamSource = res.data
        dronePara.droneList = []
        console.log('live_capacity:', dronePara.livestreamSource)
        if (dronePara.livestreamSource) {
          dronePara.livestreamSource.forEach((ele: any) => {
            dronePara.droneList.push({ label: ele.name + '-' + ele.sn, value: ele.sn, more: ele.cameras_list })
          })
        }
      }
    })
    .catch(error => {
      message.error(error)
      console.error(error)
    })
}

const deviceVideowebrtc = ref()

onMounted(() => {
  onRefresh()
  /*
   * mode: "live": 直播场景，"rtc": 通信场景，(Beta) 点对点通信模式
   * codec:  "vp8": 浏览器使用 VP8 编码,"h264": 浏览器使用 H.264 编码,"vp9": (Beta) 浏览器使用 VP9 编码,"av1": (Beta) 浏览器使用 AV1 编码
   * role: "audience": 观众，"host": 主播
  */
  agoraClient = AgoraRTC.createClient({ mode: 'live', codec: 'vp8' })
  agoraClient.setClientRole('audience', { level: 2 })// 1:低延时，2:超低延时。
  if (agoraClient.connectionState === 'DISCONNECTED') {
    // 加入频道。该方法让用户加入通话频道，在同一个频道内的用户可以互相通话。
    agoraClient.join(agoraPara.appid, agoraPara.channel, agoraPara.token)
  }
  /*
  * 监听事件：
  * user-joined: 当远端用户加入频道时触发。
  * 直播场景下，该回调提示有主播加入了频道，并返回该主播的 ID；如果在加入之前，已经有主播在频道中了，新加入的用户也会收到已有主播加入频道的回调；建议连麦主播不超过 32 人。
  * 通信场景下，该回调提示有远端用户加入了频道，并返回新加入用户的 ID；如果加入之前，已经有其他用户在频道中了，新加入的用户也会收到这些已有用户加入频道的回调；建议连麦用户不超过 32 人。
  */
  agoraClient.on('user-joined', async (user: IAgoraRTCRemoteUser) => {
    message.info('user[' + user.uid + '],加入直播')
  })
  /*
  * 监听事件：
  * user-published: 该回调通知远端用户发布了新的音频轨道或者视频轨道。
  * IAgoraRTCRemoteUser: 远端用户对象。
  * mediaType: "audio" | "video" | "datachannel" 远端用户发布的媒体类型: "audio": 远端用户发布了音频轨道,"video": 远端用户发布了视频轨道,"datachannel": 预留参数。
  *
  */
  agoraClient.on('user-published', async (user: IAgoraRTCRemoteUser, mediaType: 'audio' | 'video') => {
    await agoraClient.subscribe(user, mediaType)
    if (mediaType === 'video') {
      console.log('视频订阅成功: [' + user.uid + '], ' + mediaType)
      const remoteVideoTrack = user.videoTrack!
      // 在页面上播放媒体轨道。string: 指定该 DOM 元素的 ID 值; HTMLElement: 直接传入一个 DOM 元素对象。
      remoteVideoTrack.play(document.getElementById('player') as HTMLElement)
    }
    if (mediaType === 'audio') {
      console.log('音频订阅成功: [' + user.uid + '], ' + mediaType)
    }
  })
  /*
  * 监听事件：
  * user-unpublished: 该回调通知远端用户取消了音频轨道或者视频轨道的发布。
  */
  agoraClient.on('user-unpublished', async (user: any, mediaType: 'audio' | 'video') => {
    console.log('[' + user + '], 取消[' + mediaType + '] 订阅')
    message.info('[' + user + '], 取消[' + mediaType + '] 订阅')
  })

  /*
  * 监听事件：监测到异常事件回调.异常事件不是错误，但是一般会引起通话质量问题。发生异常事件后，如果恢复正常，也会收到该回调。
  */
  agoraClient.on('exception', async (e: any) => {
    console.log('直播异常:', e)
    message.error(e.msg)
  })
})
const handleError = (err: any) => {
  console.error(err)
}
const handleJoinChannel = (uid: any) => {
  agoraPara.uid = uid
}
const onStart = async () => {
  const that = this
  console.log(
    'drone parameter：',
    dronePara.droneSelected,
    dronePara.cameraSelected,
    dronePara.videoSelected,
    dronePara.claritySelected
  )
  const timestamp = new Date().getTime().toString()
  const liveTimestamp = timestamp
  if (
    dronePara.droneSelected == null ||
    dronePara.cameraSelected == null ||
    dronePara.claritySelected == null
  ) {
    message.warn('waring: not select live para!!!')
    return
  }

  agoraClient.setClientRole('audience', { level: 2 })
  if (agoraClient.connectionState === 'DISCONNECTED') {
    await agoraClient.join(agoraPara.appid, agoraPara.channel, agoraPara.token)
  }
  console.log('AgoraPara:', agoraPara)
  livePara.videoId = dronePara.droneSelected + '/' + dronePara.cameraSelected + '/' + (dronePara.videoSelected || nonSwitchable + '-0')
  livePara.url = 'channel=' + agoraPara.channel + '&sn=' + dronePara.droneSelected + '&token=' + encodeURIComponent(agoraPara.token) + '&uid=' + agoraPara.uid
  console.log('AgoraLivePara:', livePara.url)
  // 开启直播
  startLivestream({
    url: livePara.url,
    video_id: livePara.videoId,
    url_type: 0,
    video_quality: dronePara.claritySelected,
    // channel: agoraPara.channel
  })
    .then(res => {
      if (res.code !== 0) {
        return
      }
      livePara.liveState = true
    })
    .catch(err => {
      // code=UNEXPECTED_ERROR: 无法处理的、非预期的错误，通常这个错误会有具体的错误提示。
      // code=UNEXPECTED_RESPONSE: 服务端返回了非预期的响应。这个错误通常是在网络问题导致客户端与服务端状态不一致时抛出。
      // code=INVALID_PARAMS: 非法参数。
      // code=NOT_SUPPORTED: 浏览器不支持。
      // code=INVALID_OPERATION: 非法操作，通常是因为在当前状态不能进行该操作。
      // code=OPERATION_ABORTED: 操作中止，通常是因为网络质量差或连接断开导致与声网服务器通信失败。
      // code=WEB_SECURITY_RESTRICT: 浏览器安全策略限制。
      // code=NO_ACTIVE_STATUS: 声网项目未激活或被禁用。
      console.error('AgoraPara直播异常: ', err)
    })
}
const onStop = async () => {
  if (
    dronePara.droneSelected == null ||
    dronePara.cameraSelected == null ||
    dronePara.claritySelected == null
  ) {
    message.warn('waring: not select live para!!!')
    return
  }
  livePara.videoId =
    dronePara.droneSelected +
    '/' +
    dronePara.cameraSelected + '/' + (dronePara.videoSelected || nonSwitchable + '-0')

  stopLivestream({
    video_id: livePara.videoId
  }).then(res => {
    if (res.code === 0) {
      message.success(res.message)
      livePara.liveState = false
      dronePara.lensSelected = ''
      console.log('stop play livestream')
    }
  })
}
const onDroneSelect = async (val: SelectOption) => {
  dronePara.cameraList = []
  dronePara.videoList = []
  dronePara.lensList = []

  dronePara.cameraSelected = undefined
  dronePara.videoSelected = undefined
  dronePara.lensSelected = undefined
  dronePara.droneSelected = val.value
  agoraPara.channel = dronePara.droneSelected
  const agoraParaRes = await getAgoraToken({ appKey: CURRENT_CONFIG.agoraToken, channel: agoraPara.channel })
  if (agoraParaRes) { agoraPara.token = agoraParaRes.data }
  if (!val.more) {
    return
  }
  val.more.forEach((ele: any) => {
    dronePara.cameraList.push({ label: ele.name, value: ele.index, more: ele.videos_list })
  })
}
const onCameraSelect = (val: SelectOption) => {
  dronePara.cameraSelected = val.value
  dronePara.videoSelected = undefined
  dronePara.lensSelected = undefined
  dronePara.videoList = []
  dronePara.lensList = []
  if (!val.more) {
    return
  }

  val.more.forEach((ele: any) => {
    dronePara.videoList.push({ label: ele.type, value: ele.index, more: ele.switch_video_types })
  })
  if (dronePara.videoList.length === 0) {
    return
  }
  const firstVideo: SelectOption = dronePara.videoList[0]
  dronePara.videoSelected = firstVideo.value
  dronePara.lensList = firstVideo.more
  dronePara.lensSelected = firstVideo.label
  dronePara.isDockLive = dronePara.lensList?.length > 0
}
const onVideoSelect = (val: SelectOption) => {
  dronePara.videoSelected = val.value
  dronePara.lensList = val.more
  dronePara.lensSelected = val.label
}
const onClaritySelect = (val: any) => {
  dronePara.claritySelected = val
}
const onUpdateQuality = () => {
  if (!livePara.liveState) {
    message.info('请先打开直播.')
    return
  }
  setLivestreamQuality({
    video_id: livePara.videoId,
    video_quality: dronePara.claritySelected
  }).then(res => {
    if (res.code === 0) {
      message.success('将清晰度设置为 ' + clarityList[dronePara.claritySelected].label)
    }
  })
}

const onSwitch = () => {
  if (dronePara.lensSelected === undefined || dronePara.lensSelected === nonSwitchable) {
    message.info('The ' + nonSwitchable + ' 镜头无法切换，请选择要切换的镜头.', 8)
    return
  }
  changeLivestreamLens({
    video_id: livePara.videoId,
    video_type: dronePara.lensSelected
  }).then(res => {
    if (res.code === 0) {
      message.success('切换实时摄像头成功.')
    }
  })
}
</script>

<style lang="scss" scoped>
@use '/@/styles/index.scss' as *;
</style>
